import { apiUrl, authHeaders, authJsonHeaders } from "./httpAuth";

export async function createCaceria(payload) {
    const res = await fetch(apiUrl("api/cacerias/create"), {
        method: "POST",
        headers: authJsonHeaders(),
        body: JSON.stringify(payload),
    });

    if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.message || "Error al crear");
    }

    return res.json().catch(() => null);
}

export async function updateCaceria(id, payload) {
    const res = await fetch(apiUrl(`api/cacerias/${id}`), {
        method: "PUT",
        headers: authJsonHeaders(),
        body: JSON.stringify(payload),
    });

    if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.message || "Error al actualizar");
    }

    return res.json().catch(() => null);
}

export async function deleteCaceria(id) {
    const res = await fetch(apiUrl(`api/cacerias/${id}`), {
        method: "DELETE",
        headers: authHeaders(),
    });

    if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.message || "Error al eliminar");
    }
    return true;
}

export async function duplicateCaceria(id) {
    const res = await fetch(apiUrl(`api/cacerias/${id}/duplicate`), {
        method: "POST",
        headers: authHeaders(),
    });

    if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.message || "Error al duplicar la cacería");
    }

    return res.json().catch(() => null);
}
